module.exports = __webpack_public_path__ + "img/info.0a94b347.svg";